import { computed, ComputedRef } from 'vue'

import { NotificationPresenter } from '../notification/notificationPresenter'

import { ViewModeType } from '@/domain/value_objects/config/viewModeType'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { ConfigStateViewModel } from '@/presentation/viewmodels/config/configStateViewModel'

export class ConfigStatePresenter {
  private viewModel: ConfigStateViewModel

  constructor(viewModel: ConfigStateViewModel) {
    this.viewModel = viewModel
  }

  get viewMode(): ComputedRef<ViewModeType> {
    return this.viewModel.viewMode
  }

  get displayLanguage(): ComputedRef<DisplayLanguageType> {
    return this.viewModel.displayLanguage
  }

  get programLanguage(): ComputedRef<ProgramLanguageType> {
    return this.viewModel.programLanguage
  }

  get editorFontSize(): ComputedRef<number> {
    return this.viewModel.editorFontSize
  }

  get windowWidth(): ComputedRef<number> {
    return computed(() => this.viewModel.windowWidth.value)
  }

  get windowHeight(): ComputedRef<number> {
    return computed(() => this.viewModel.windowHeight.value)
  }

  isLightMode(): boolean {
    return this.viewMode.value === 'LIGHT'
  }

  setViewMode(viewMode: ViewModeType): void {
    this.viewModel.setViewMode(viewMode)
  }

  reverseViewMode(): void {
    const viewMode = this.viewMode.value === 'LIGHT' ? 'DARK' : 'LIGHT'
    this.viewModel.setViewMode(viewMode)
  }

  setDisplayLanguage(displayLanguage: DisplayLanguageType): void {
    this.viewModel.setDisplayLanguage(displayLanguage)
  }

  setProgramLanguage(programLanguage: ProgramLanguageType): void {
    this.viewModel.setProgramLanguage(programLanguage)
  }

  setEditorFontSize(editorFontSize: number): void {
    this.viewModel.setEditorFontSize(editorFontSize)
  }

  updateWindowSize(): void {
    this.viewModel.updateWindowSize()
  }

  copyClipboard(text: string): void {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        new NotificationPresenter().copyNotification()
      })
      .catch(e => {
        console.error(e)
      })
  }
}
